
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/splitbox.zh.md?watch=parent';
    export const toc = [{"id":"splitbox","depth":2,"title":"SplitBox"}];
export const frontmatter = {"title":"SplitBox","toc":"menu","filename":"docs/temp/ui/splitbox.zh.md","lastUpdated":1687013004000,"order":12,"redirect_from":["/zh/docs","/zh/docs/api","/zh/docs/api/ui"],"description":"拆分面板。"};